import '/app/brewery-packages/content/content-editor-plugin-unordered-list/src/UnorderedList.css-raw';
export default {
  "unorderedList": "about-us-b998e096-unorderedList-wCRGkq"
};